import { useLocation } from 'react-router';
import { NavLinkProps } from 'react-router-dom';

/**
 * Hook to determine if a link is active based on the current location.
 * @param to The link the entry should point to
 * @param exact Whether the link should be an exact match
 * @returns Whether the link is active
 */
export function useIsLinkActive(to: NavLinkProps['to'], exact = false) {
  const location = useLocation();
  if (exact) {
    return to === location.pathname;
  }

  return location.pathname.includes(to.toString());
}
